import { render, staticRenderFns } from "./FoodWindow.vue?vue&type=template&id=ef63b364&scoped=true&"
import script from "./FoodWindow.vue?vue&type=script&lang=js&"
export * from "./FoodWindow.vue?vue&type=script&lang=js&"
import style0 from "./FoodWindow.vue?vue&type=style&index=0&id=ef63b364&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef63b364",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})
